import React from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Box,
  Skeleton,
  Typography,
} from "@mui/material";

export default function StyleCard({ styleDoc, fallbackImage, onPick }) {
  const img = styleDoc?.images?.primary || fallbackImage || "";
  const title = styleDoc?.displayName || styleDoc?.name || "Wedding style";

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 3,
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}>
      <CardActionArea onClick={onPick} sx={{ textAlign: "left" }}>
        {img ? (
          <Box
            sx={{
              position: "relative",
              width: "100%",
              aspectRatio: { xs: "4/5", sm: "3/4" },
              borderBottom: 1,
              borderColor: "divider",
            }}>
            {img ? (
              <Box
                component="img"
                src={img}
                alt={title}
                sx={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            ) : (
              <Skeleton
                variant="rectangular"
                sx={{ position: "absolute", inset: 0 }}
              />
            )}
          </Box>
        ) : (
          <Skeleton variant="rectangular" height={260} />
        )}
        <CardContent sx={{ p: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            {title}
          </Typography>
          {styleDoc?.variant && (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: "block" }}>
              {styleDoc.variant === "tall"
                ? "Tall tiers (~6″)"
                : "Standard tiers (~4″)"}
            </Typography>
          )}
          {Array.isArray(styleDoc?.tags) && styleDoc.tags.length > 0 && (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: "block", mt: 0.5 }}>
              {styleDoc.tags.join(" • ")}
            </Typography>
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
